export const WORK_ORDER_TYPES = [
  "Basement Remodel",
  "Bathroom Remodel",
  "Epoxy Flooring",
  "General Construction",
  "Kitchen Remodel",
  "Solar Install",
  "Solar Connection",
  "Excavation",
  "Concrete (Footings)",
  "HVAC (Underground)",
  "Plumbing (Underground)",
  "Electrical (Underground)",
  "Concrete (Slab)",
  "Hardscape",
  "Framing (Rough-In)",
  "Roofing (Flat)",
  "Roofing (Sloped)",
  "Roofing (Metal)",
  "Siding",
  "Soffit/Fascia",
  "Gutters",
  "Windows",
  "HVAC (Rough-In)",
  "Plumbing (Rough-In)",
  "Electrical (Rough-In)",
  "Framing (Trim)",
  "Masonry",
  "Insulation",
  "Drywall",
  "Painting",
  "Tile",
  "HVAC (Trim)",
  "Plumbing (Trim)",
  "Electrical (Trim)",
  "Landscape",
  "Irrigation",
  "Appliance",
  "Miscellaneous",
  "Demo",
  "Door",
  "Skylight",
] as const;

export type WorkOrderType = typeof WORK_ORDER_TYPES[number]; 